//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import ContainerRowTitle from '../../components/common/ContainerRowTitle'
import ContainerRowError from '../../components/common/ContainerRowError'
import ContainerRowInstructionLink from '../../components/common/ContainerRowInstructionLink'
import InvoiceHeaderContainer from './InvoiceHeaderContainer'

const InvoiceDataExtractionForm = props => {
    const { eros,location } = props;
    const query = queryString.parse(location.search);
    
    if (!query.jwt || !query.docUrl || !query.taskAcceptedInfoId ) {
        return (
            <div className="container">
               <ContainerRowSpace />
               <ContainerRowTitle title={'Invoice Data Extraction'} />
               <ContainerRowError errorMsg={'Missing Parameters!'} /> 
            </div>
        )
    }
    
    return (
        <div className="container">
            <ContainerRowSpace />
            <ContainerRowTitle title={'Invoice Data Extraction'} />
            <ContainerRowInstructionLink docLink={query.docUrl} instructionLink={'https://docs.google.com/document/d/e/2PACX-1vRYJ9YcXqFUr3hRa4NFGSCojVkp0Qdjx-_sgmPk9WvKvn8t-Cisud-Z6Cd4DspKF0KfUaZ9JG3PFcRd/pub?embedded=true'} />
            <InvoiceHeaderContainer query={query}/>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        eros: state.eros
    }
}

export default connect(mapStateToProps)(InvoiceDataExtractionForm);


// WEBPACK FOOTER //
// ./src/views/ProjectEros/InvoiceDataExtractionForm.js